/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Question/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import BackAction from './BackAction/index'
import Captcha from './Captcha/index'
import Content from './Content/index'
import NextAction from './NextAction/index'
import Progress from './Progress/index'
import Prompt from './Prompt/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Question({
  children,
  viewPath = "/App/Widget/Content/Questions/Question"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Question.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Progress
  viewPath={`${viewPath}/Progress`}
/>
<div
  data-testid="Question.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-Z1iwBUS': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<BackAction
  viewPath={`${viewPath}/BackAction`}
/>
<Prompt
  viewPath={`${viewPath}/Prompt`}
/>
</div>
<Content
  viewPath={`${viewPath}/Content`}
/>
<NextAction
  viewPath={`${viewPath}/NextAction`}
/>
<Captcha
  viewPath={`${viewPath}/Captcha`}
/>
</div>
{children}
</React.Fragment>)
}